import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-441f94fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dark:border-gray-600 dark:border-0 space-y-2 levels-select-list scrollbar w-full bg-transparent" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "rounded space-y-2 mt-2 bg-slate-400" }
const _hoisted_4 = { class: "flex justify-between items-center w-full focus:outline-none focus-visible:outline-black dark:focus-visible:outline-white pl-2" }
const _hoisted_5 = { class: "flex mb-0 normal-case text-lg pl-2 flex-grow w-1/2 overflow-hidden" }
const _hoisted_6 = {
  key: 0,
  class: "options-list"
}
const _hoisted_7 = { class: "pr-1" }

import {onMounted, PropType, ref,} from "vue";
import Card from "@/Components/General/Card.vue";
import {mdiArrowRightBottom, mdiCheckCircle, mdiChevronDown} from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition";
import TextButton from "@/Components/Buttons/TextButton.vue";
import OptionBox from "@/Components/General/LevelsSelect/OptionBox.vue";
import {Option} from "@/types/LevelsSelectTypes/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelsSelectList',
  props: {
  options: {
    type: Object as PropType<Option[] | undefined>,
    required: true,
  },
  selectedOption: {
    type: Object as PropType<Option | null | undefined>,
    required: false,
  },
  expanded: {
    type: Array as PropType<any[]>,

    default: [],
  },
},
  emits: ["selectOption"],
  setup(__props, { emit }) {

const props = __props;




const expanded = ref<any>(props.expanded ?? [])
const isExpanded = (option: Option) => {
// check if expanded contains any selected sub options
  return expanded.value?.includes(option.id);
};
const expand = (parent: Option) => {
  expanded.value.push(parent.id)


};
const collapse = (parent: Option) => {
  expanded.value = expanded.value.filter((id: any) => id !== parent.id)

};

const toggleExpansion = (parent: Option) => {
  if (isExpanded(parent)) {
    collapse(parent);
    return;
  }
  expand(parent);
};
const selectOption = (event: any, option: Option) => {
  if (Array.isArray(event)) {
    if (!option) {
      option = event[1];
    }
    event = event[0]

  }
  event.stopPropagation()
  if (event.pointerId == 1) {
    emit("selectOption", [event, option?.id == props.selectedOption?.id ? null : option]);
  }
};
const selectedClasses = (option: Option) => {
  if (option?.id === props.selectedOption?.id) {
    return "md:bg-gray-300 dark:bg-gray-900 dark:bg-opacity-100 focus:outline-none focus-visible:outline-black dark:focus-visible:outline-white";
  }

  return "";
}
const scrollToSelectedOption = () => {
  const selectedOptionElement = document.getElementById(`selected-option-${props.selectedOption?.id}`);

  if (selectedOptionElement) {
    selectedOptionElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
onMounted(() => {
  scrollToSelectedOption()
})

return (_ctx: any,_cache: any) => {
  const _component_levels_select_list = _resolveComponent("levels-select-list", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.options?.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Ingen kategorier!"))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.options, (parent) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(TextButton, {
              onClick: _withModifiers((event)=>selectOption(event, parent), ["stop"]),
              color: "black",
              id: parent.id === __props.selectedOption?.id ? 'selected-option-'+ parent.id : '',
              class: "w-full pl-2 dark:border-gray-600 rounded"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  (parent.id === __props.selectedOption?.id)
                    ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                        key: 0,
                        type: "mdi",
                        class: "text-green-700 w-6 h-6 mr-2",
                        path: _unref(mdiCheckCircle)
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true),
                  (parent.parent_id)
                    ? (_openBlock(), _createBlock(_unref(SvgIcon), {
                        key: 1,
                        type: "mdi",
                        class: "w-4 h-4",
                        path: _unref(mdiArrowRightBottom)
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(parent.label), 1),
                  (parent.expandable != false)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["transition-transform", isExpanded(parent) ? ' transform rotate-180' : ''])
                      }, [
                        _createVNode(_unref(SvgIcon), {
                          onClick: _withModifiers(($event: any) => (toggleExpansion(parent)), ["stop"]),
                          type: "mdi",
                          path: _unref(mdiChevronDown)
                        }, null, 8, ["onClick", "path"])
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["onClick", "id"]),
            _createVNode(_unref(CollapseTransition), null, {
              default: _withCtx(() => [
                (isExpanded(parent))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parent.options, (option) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (option.options && option.options?.length > 0)
                            ? (_openBlock(), _createBlock(_component_levels_select_list, {
                                key: 0,
                                class: _normalizeClass(selectedClasses),
                                expanded: expanded.value,
                                onSelectOption: selectOption,
                                options: [option],
                                selectedOption: __props.selectedOption
                              }, null, 8, ["expanded", "options", "selectedOption"]))
                            : (_openBlock(), _createBlock(OptionBox, {
                                key: 1,
                                onClick: _withModifiers((event)=>selectOption(event,option), ["stop"]),
                                class: "hover:bg-grey-100 mt-4",
                                id: option.id === __props.selectedOption?.id ? 'selected-option-'+ parent.id : '',
                                option: option,
                                selected: option.id === __props.selectedOption?.id,
                                onSelectOption: (event)=>selectOption(event,option)
                              }, null, 8, ["onClick", "id", "option", "selected", "onSelectOption"]))
                        ]))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 256))
  ]))
}
}

})